import { render, staticRenderFns } from "./ManagerDashBoard.vue?vue&type=template&id=2a4ce87a&"
import script from "./ManagerDashBoard.vue?vue&type=script&lang=js&"
export * from "./ManagerDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDashBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports